<template>
  <b-form @submit.prevent="submit">
    <header-page-layout
      page-title="Editing Template"
      :back-to="{ name: 'templates-index' }"
      back-text="Templates"
    >
      <template slot="actions">
        <b-button variant="outline-primary" type="submit">Save</b-button>
      </template>

      <b-card
        header="Details"
        header-tag="h4"
        header-bg-variant="white"
        class="mb-3"
      >
        <b-container>
          <b-row>
            <b-col>
              <b-form-group
                label="Name"
                required
                label-cols-lg="3"
              >
                <b-form-input v-model="name"></b-form-input>
              </b-form-group>

              <b-form-group
                label="Description"
                label-cols-lg="3"
              >
                <b-form-input v-model="description"></b-form-input>
              </b-form-group>

              <b-form-group
                label-cols-lg="3"
              >
                <b-form-checkbox
                  unchecked-value="false"
                  v-model="active"
                >
                  Active
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
      </b-card>

      <b-card
        header="Template Editor"
        header-tag="h4"
        header-bg-variant="white"
      >
        <b-container fluid>
          <b-row>
            <b-col>
              <template-editor
                :show-subject-editor="false"
              ></template-editor>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </header-page-layout>
  </b-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TemplateEditor from '@/components/TemplateEditor'
import HeaderPageLayout from '@/components/HeaderPageLayout'
import store from '@/store'

export default {
  components: {
    HeaderPageLayout,
    TemplateEditor
  },

  async beforeRouteEnter(to, from, next) {
    if ('id' in to.params) {
      await store.dispatch('templates/fetchOne', to.params.id)
    } else {
      await store.dispatch('templates/newTemplate')
    }

    // TODO: maybe make this an email action to reset everything
    const template = store.state.templates.template
    store.commit('emails/updateDocument', template.document)
    store.commit('emails/updateMode', template.rawMode)
    store.commit('emails/updatePreviewHtml', template.document_html)
    store.commit('emails/updateSubject', '')
    store.commit('emails/updatePreviewSubject', '')
    store.commit('emails/resetResource')

    next()
  },

  // Keep stage doc and rendered html sync'd with emails module
  watch: {
    document: {
      handler(val) {
        this.updateAttribute({ attribute: 'document', value: val })
        if(!val.rawMode)
          this.updateAttribute({ attribute: 'document_html', value: this.previewHtml })
      },
      deep: true
    }
  },

  computed: {
    ...mapState('templates', [
      'template',
      'templates'
    ]),

    ...mapState('emails', [
      'document',
      'rawMode',
      'previewHtml'
    ]),

    name: {
      get() { return this.$store.state.templates.template.name },
      set(value) { this.updateAttribute({ attribute: 'name', value }) }
    },

    description: {
      get() { return this.$store.state.templates.template.description },
      set(value) { this.updateAttribute({ attribute: 'description', value }) }
    },

    active: {
      get() { return this.$store.state.templates.template.active },
      set(value) { this.updateAttribute({ attribute: 'active', value }) }
    }
  },

  methods: {
    ...mapActions('templates', [
      'newTemplate',
      'saveTemplate',
      'fetchOne',
      'updateTemplate',
      'updateAttribute',
      'previewTemplate'
    ]),

    async submit() {
      store.commit('updateAttribute', { attribute: 'document', value: this.document })
      if(!this.rawMode)
        store.commit('updateAttribute', { attribute: 'document_html', value: this.document.render() })
      await this.saveTemplate()
      this.$router.push({ name: 'templates-index' })
    }
  }
}
</script>
